import Cookies from "js-cookie";

export const storeToken = (token) => {
  Cookies.set("accessToken", token, { expires: 1 });
};

export const getToken = () => {
  return Cookies.get("accessToken");
};

export const getPatientAccessToken = () => {
  return Cookies.get("patientAccessToken");
};
export const getAdminAccessToken = () => {
  return Cookies.get("adminAccessToken");
};

export const removeToken = () => {
  Cookies.remove("accessToken");
};

export const accessToken = () => {
  Cookies.get("accessToken");
};

export const isTokenExpired = () => {
  const token = getToken();
  if (!token) {
    return true;
  }
  return false;
};
